import request from '@/service/http'

export function init (data) {
  return request({
    url: '/api/stuDashboard/init',
    method: 'post',
    data: data,
  })
}

export function getCertificate (data) {
  return request({
    url: '/api/stuDashboard/getCertificate',
    method: 'post',
    data: data,
  })
}


export function doSignIn (data) {
  return request({
    url: '/api/stuDashboard/classSignIn',
    method: 'post',
    data: data,
  })
}
